var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Imprimir'),expression:"'Imprimir'"}],attrs:{"icon":"","type":"light","size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconPrint',{attrs:{"size":_vm.size}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }